"use client";

import { useSyncExternalStore } from "react";
import {
  APPEARANCE_STORAGE_KEY,
  type AppearanceSettings,
  applyAppearance,
  parseAppearance,
} from "@/lib/browser/appearance";
import { createLocalStorageStore } from "@/lib/browser/local-storage-store";

const appearanceStore = createLocalStorageStore({
  key: APPEARANCE_STORAGE_KEY,
  parse: parseAppearance,
  onChange: applyAppearance,
});

/** 保存して画面へ反映する。容量を超えたときはlocalStorageの例外をそのまま投げる。 */
export function saveAppearance(next: AppearanceSettings) {
  appearanceStore.save(next);
}

/** 保存した見た目。使っている間は、ほかのタブでの変更もこのタブへ反映する。 */
export function useAppearance() {
  return useSyncExternalStore(
    appearanceStore.subscribe,
    appearanceStore.read,
    appearanceStore.readServer,
  );
}
